import api from "../../../api";

const API_URL = "/audit/competencies";

export async function getCompetencyRequestsByUser(userId) {
  try {
    const res = await api.get(`${API_URL}/requests/user/${userId}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching competency requests:', error);
    throw error;
  }
}
